var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibilityIconAr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33464 5.91667C6.79487 5.91667 7.16797 5.54357 7.16797 5.08333C7.16797 4.6231 6.79487 4.25 6.33464 4.25H2.16797C1.70773 4.25 1.33464 4.6231 1.33464 5.08333V9.25C1.33464 9.71024 1.70773 10.0833 2.16797 10.0833C2.62821 10.0833 3.0013 9.71024 3.0013 9.25V7.09518L6.57871 10.6726C6.90415 10.998 7.43179 10.998 7.75722 10.6726L9.66797 8.76184L13.2454 12.3393C13.5708 12.6647 14.0985 12.6647 14.4239 12.3393C14.7493 12.0138 14.7493 11.4862 14.4239 11.1607L10.2572 6.99408C9.93179 6.66864 9.40415 6.66864 9.07871 6.99408L7.16797 8.90482L4.17981 5.91667H6.33464Z",
    fill: "#399D81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityIconAr);
export default __webpack_public_path__ + "static/media/visibility-icon-ar.dde4ac81a2951ff53485eef27060c70c.svg";
export { ForwardRef as ReactComponent };